import {
  type InvokeActionFn,
  MasonryEngineNodeAction,
  useMasonryEngineActionEmitter,
} from '@leagueplatform/masonry-engine';
import { MasonryDriverAction } from '#types/masonry-driver-node-actions.ts';

/**
 * A hook that returns an function for invoking Masonry actions.
 */
export const useInvokeAction = <
  Action extends MasonryEngineNodeAction = MasonryDriverAction,
>(): InvokeActionFn<Action, true> => useMasonryEngineActionEmitter<Action>();
